import * as swcHelpers from '@swc/helpers';
import { mapStoresResult } from '../hooks/api/adapters/mapStoresResult.js';
import '../types.js';

const mapAvailableFiltersToResults = (availableFilters, filteredResults)=>{
    const updatedFilters = availableFilters === null || availableFilters === void 0 ? void 0 : availableFilters.filters.map((filter)=>{
        const matchingFilterInResults = filteredResults === null || filteredResults === void 0 ? void 0 : filteredResults.filters.find((f)=>f.name === filter.name
        );
        return swcHelpers.objectSpread({}, filter, {
            options: filter.options.map((option)=>{
                const matchingOptionInResults = matchingFilterInResults === null || matchingFilterInResults === void 0 ? void 0 : matchingFilterInResults.options.find((o)=>o.name === option.name
                );
                return swcHelpers.objectSpread({}, option, {
                    count: matchingOptionInResults ? matchingOptionInResults.count : 0
                });
            })
        });
    });
    return {
        results: mapStoresResult(filteredResults === null || filteredResults === void 0 ? void 0 : filteredResults.results),
        filters: updatedFilters
    };
};

export { mapAvailableFiltersToResults };
//# sourceMappingURL=map-available-filters-to-results.js.map
